import { FC } from 'react';

import SubProductTypeListing from 'components/main/SubProductType';

const SubProductType: FC = () => <SubProductTypeListing />;

export default SubProductType;
